require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./grand-public-0-7-3.json") })
        }
      }, "path---grand-public-0-7-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---grand-public-0-7-3!./.cache/json/grand-public-0-7-3.json
// module id = 452
// module chunks = 231608221292675